import { useConsent } from '@printdeal/consent-management/react';
import { createContext } from 'react';

export interface ISegmentContext {
  isSegmentAnalyticsReady: boolean;
  consentData?: ReturnType<typeof useConsent>;
  isConsentReady: boolean;
}

const defaultValue: ISegmentContext = {
  isSegmentAnalyticsReady: false,
  isConsentReady: false,
};

const SegmentContext = createContext(defaultValue);

export default SegmentContext;
